export const formatMaskedCardNumber = (cardNumber: string): string => {
  const isAmex = /^(34|37)/.test(cardNumber);

  if (isAmex) {
    // Format: **** ****** 12345 (AMEX)
    const lastFive = cardNumber.slice(-5);
    const maskedPart = "*".repeat(9);
    return `${maskedPart.slice(0, 4)} ${maskedPart.slice(4)} ${lastFive}`;
  } else {
    // Format: **** **** **** 1234 (Other cards)
    const lastFour = cardNumber.slice(-4);
    const maskedPart = "*".repeat(12);
    return `${maskedPart.slice(0, 4)} ${maskedPart.slice(4, 8)} ${maskedPart.slice(8, 12)} ${lastFour}`;
  }
};
